// packages/i18n/src/index.ts
import { sprintf } from "./sprintf.mjs";
export * from "./create-i18n.mjs";
import {
  default as default2,
  setLocaleData,
  resetLocaleData,
  getLocaleData,
  subscribe,
  __,
  _x,
  _n,
  _nx,
  isRTL,
  hasTranslation
} from "./default-i18n.mjs";
export {
  __,
  _n,
  _nx,
  _x,
  default2 as defaultI18n,
  getLocaleData,
  hasTranslation,
  isRTL,
  resetLocaleData,
  setLocaleData,
  sprintf,
  subscribe
};
//# sourceMappingURL=index.mjs.map
